

















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { db, userData } from '../main';
import Activities from '@/components/Activities.vue';
import stravaImporter from '../modules/StravaImporter';
import Entry from '@/entities/Entry';

Vue.component('Activities', Activities);

@Component({props: ['disabled', 'quickAdd', 'newDateTime']})
export default class RegisterActivity extends Vue {
    name = 'RegisterActivity';
    minutes: null | string = null;
    link: string = '';
    components = {
        Activities,
    };
    importing = false;
    endo = {
        userName: '',
        password: ''
    }

    userData = userData;

    data() {
        return {
            datetime: new Date(),
        };
    };

    get disableSave() {
        return this.minutes == null;
    }

    save() {
        if(this.disableSave)
            return;


        this.saveActivity(userData.selectedActivity.id, this.minutes, userData.selectedActivity.mets, this.link, userData.selectedActivity.text, '', this.$data.datetime);
        userData.user.favoriteActivity = userData.selectedActivity.id;
        userData.saveUser();
    }

    isValidLink(link: string): boolean
    {
        const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
        const regex = new RegExp(expression);

        return Boolean(link.match(regex));
    }

    saveActivity(activityId: string, minutes: string|null, mets: number, link: string, activityText: string, importId: string, datetime: Date) {
        const ref = db.collection('entries').doc();
        const mins = minutes == null ? 0 : minutes;
        let validLink: string | null = null;
        if (link.length > 0 && !this.isValidLink(link)) {
            this.$toast.open({
                message: 'Falaktigt format på länken. Kom ihåg http/https.',
                position: 'is-top',
                type: 'is-danger'
            });
            return;
        }
        const act = {
            mets: mets,
            minutes: minutes,
            kcal: (mets * (userData.user.weight ? userData.user.weight : 75) * (<number>mins  / 60)).toFixed(0),
            aid: activityId,
            cid: userData.challenge.id,
            uid: userData.user.uid,
            created: datetime,
            import_id: importId,
            link: link
        };
        this.updateUserStats(act);
        var setWithMerge = ref.set(act, { merge: true }).then(() => {
            this.$toast.open({
                message: minutes + ' minuter ' + activityText + ' tillagt',
                position: 'is-top',
                type: 'is-success'
            });
        })
        .then(() => {
            this.minutes = '0';
            this.link = '';
        })
        .catch(e => console.log(e));
        return setWithMerge;
    }

    updateUserStats(act) {
        // Ugly hack because FB is slow to propagate 
        const stats = this.userData.statsData.userStats.find(x => x.cid == act.cid && x.uid == act.uid);
        if(stats) {
            stats.totalPoints += Number(act.minutes) * act.mets;
            stats.totalKcal += Number(act.kcal);
            stats.totalMinutes += Number(act.minutes);
            stats.totalNumber += 1;
        }
    }

    mounted() {
        const stravaCode = this.$route.query.code;
        if(!stravaCode)
            return;
        stravaImporter.doImport(<string>stravaCode).then(entries => {
            if(this.$props.quickAdd)
                return;
            
            this.$toast.open({
                message: 'Importerar...',
                position: 'is-top'
            });
            userData.loadChallenges().then(() => {
                userData.loadEntries(this.$route.params.userId);
                this.$router.push({ name: 'ActivityList', params: { userId: this.$route.params.userId } })
                setTimeout(() => {
                    let numOfImports = 0;
                    entries.forEach((e:any) => {
                        let date = new Date(e.start_date);
                        if(date > userData.challenge.startdate && date < userData.challenge.enddate) {
                            let act: any = null;
                            if(e.type == 'Run') {
                                if(e.speed < 4.3) 
                                    act = userData.activities.find((a:any) => a.id == 'GoVsauDModSzhqsvlRt8');
                                else if(e.speed < 4.8)
                                    act = userData.activities.find((a:any) => a.id == 'orRILUtzEQripFpCBv2S');
                                else if(e.speed < 5.3)
                                    act = userData.activities.find((a:any) => a.id == 'Np0XNmsrpvQFFi0lJhXJ');
                                else if(e.speed < 5.8)
                                    act = userData.activities.find((a:any) => a.id == 'yRgnfVYGujFGVqGUntjQ');
                                else
                                    act = userData.activities.find((a:any) => a.id == 'Hm9afyKMaBLcHmNvlXC3');
                            }
                            else if(e.type == 'Walk') {
                                 if(e.speed < 9.5) 
                                    act = userData.activities.find((a:any) => a.id == 'TIpFPTQLGg3MZCDAfODs');
                                else if(e.speed < 10.5)
                                    act = userData.activities.find((a:any) => a.id == '1HNXO6jpRxIpIBOVVhw3');
                                else
                                    act = userData.activities.find((a:any) => a.id == 'mSUve4vXHS6QO0xtg2mK');
                            }
                            else if(e.type == 'Ride')
                                    act = userData.activities.find((a:any) => a.id == 'YOSIkzBQwwJ85oDaSIhv');
                            else if(e.type == 'VirtualRide')
                                    act = userData.activities.find((a:any) => a.id == 'Pv4EQeNd1o668ujQSovi');
                            else if(e.type == 'Crossfit')
                                    act = userData.activities.find((a:any) => a.id == 'ilqLsIUT7EDKpQsJtyRl');
                                
                            if(act && !userData.entriesData.entries.find((entry:any) => entry.import_id == e.id)) {
                                this.saveActivity(act.id, e.minutes.toFixed(0), act.mets, e.link, act.text, e.id, date);
                                numOfImports++;
                            }
                        }
                    });
                    this.$toast.open({
                        message: 'Importerade ' + numOfImports + ' aktivitet/er',
                        position: 'is-top'
                    });
                }, 2000)
            });
        }).catch(() => {
            this.$toast.open({
                message: 'Importen misslyckades :(',
                position: 'is-top',
                type: 'is-danger'
            });
        })
    }
    importData() {
        stravaImporter.authorize();
    }

    @Watch ('$props.newDateTime')
    newDateChange() {
        this.$data.datetime = this.$props.newDateTime
    }
}
